<template>
    <div class="audit-equipment-comments">
        <div class="mb-3">
            <b-card-header class="d-flex align-items-center justify-content-between">
                <h3 class="mb-sm-0">Comments</h3>
                <b-button
                    v-if="!addingComment"
                    class="mt-2 mt-sm-0 btn-light"
                    variant="primary"
                    @click="addComment">
                    Add Comment
                </b-button>
            </b-card-header>
            <b-card-body>
                <table class="table">
                    <tr v-if="addingComment" class="comment-area">
                        <td colspan="4">
                            <b-form-textarea v-model="commentText" rows="2"/>
                            <b-button
                                :disabled="!commentText"
                                @click="submitComment"
                                class="float-right mt-2"
                                variant="primary">
                                Submit
                            </b-button>
                            <b-button @click="cancelComment" class="float-right mt-2 mr-2" variant="danger">Cancel
                            </b-button>
                        </td>
                    </tr>
                    <tr v-for="comment in auditEquipmentComments" :key="comment.id">
                        <td>
                            <user-details :user="comment.user"/>
                        </td>
                        <td>
                            <b-badge v-if="comment.isAuditorForAudit" variant="danger">Is Auditor</b-badge>
                        </td>
                        <td>
                            <timestamp :date="comment.created"/>
                        </td>
                        <td colspan="2">{{ comment.comment }}</td>
                    </tr>
                </table>
            </b-card-body>
        </div>
    </div>
</template>

<script>
import UserDetails from '@/components/UserDetails'

export default {
    name: 'AuditEquipmentComments',
    components: { UserDetails },
    props: {
        auditEquipmentComments: Array,
        auditEquipmentId: Number,
    },
    data () {
        return {
            addingComment: false,
            commentText: ''
        }
    },
    methods: {
        addComment () {
            this.addingComment = true
        },
        cancelComment () {
            this.addingComment = false
            this.commentText = ''
        },
        submitComment () {
            const comment = {
                comment: this.commentText,
                user_id: this.$user.userId(),
                audit_equipment_id: this.auditEquipmentId
            }

            this.$api.createItem(this, 'audit-equipment-comment', comment).then((response) => {
                this.addingComment = false
                this.$emit('comment-added')
            }, (error) => {
                this.$toasted.show('Error adding comment ' + error)
            })

            this.commentText = ''
        },
        isAuditorForAudit (user) {

        }
    }
}
</script>

<style scoped>

.comment-area {
    background-color: #eeeeee;
}

</style>